import { Routes, Route } from "react-router";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import UserDetail from "./pages/UserDetail";
import Roles from "./pages/Roles";
import Apps from "./pages/Apps";
import FeatureFlags from "./pages/FeatureFlags";
import BugReports from "./pages/BugReports";
import Jobs from "./pages/Jobs";
import Organizations from "./pages/Organizations";
import Scopes from "./pages/Scopes";
import Voices from "./pages/Voices";
import AICredits from "./pages/AICredits";
import { GuestUploadPage } from "../guest-upload";

/**
 * Admin routes - Admin dashboard and management
 * Protected by AdminGuard (admin role only)
 */

export default function AdminRoutes() {
  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="users" element={<Users />} />
      <Route path="users/:userId" element={<UserDetail />} />
      <Route path="roles" element={<Roles />} />
      <Route path="apps" element={<Apps />} />
      <Route path="flags" element={<FeatureFlags />} />
      <Route path="bugs" element={<BugReports />} />
      <Route path="jobs" element={<Jobs />} />
      <Route path="orgs" element={<Organizations />} />
      <Route path="scopes" element={<Scopes />} />
      <Route path="voices" element={<Voices />} />
      <Route path="credits" element={<AICredits />} />
      <Route path="guest-uploads" element={<GuestUploadPage />} />
    </Routes>
  );
}
